import { v4 as uuidv4 } from 'uuid'

import { getVisitorUuidCookies, setVisitorUuidCookies } from '@infrastructure/Cookies'

export const getVisitorUuid = (): string => {
    let visitorUuid = getVisitorUuidCookies()

    if (!visitorUuid) {
        visitorUuid = uuidv4()
        setVisitorUuidCookies(visitorUuid)
    }

    return visitorUuid
}
